import { Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/js/all.min.js';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Role from './pages/Role';
import User from './pages/User';
import Rapport from './pages/Rapport';
import Profil from './pages/Profil';
import PrivateRoute from './pages/PrivateRoute';
import PageNotFound from './pages/PageNotFound';
import Logout from './pages/Logout';
import ForgetPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';


function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route element={<PrivateRoute />} >
          <Route path="/rapport/frontend/" element={<Rapport />} />
          <Route path="/rapport/frontend/rapport" element={<Rapport />} />
          <Route path="/rapport/frontend/user" element={<User />} />
          <Route path="/rapport/frontend/profil/:id" element={<Profil />} />
          <Route path="/rapport/frontend/role" element={<Role />} />
          <Route path="/rapport/frontend/logout" element={<Logout />} />
        </Route>
        <Route path="/rapport/frontend/forget-password" element={<ForgetPassword />} />
        <Route path="/rapport/frontend/reset-password/:token" element={<ResetPassword />} />
        <Route path="/rapport/frontend/login" element={<Login />} />
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </>
  );
}


export default App;
